import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IOneBrandPayload {
    brandId: string
}

export interface IOneBrandState {
    status: string
    data: null
    errors: any
}

const initialState: IOneBrandState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const oneBrand = createSlice({
    name: 'onbordingOrganizer/one-brand',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IOneBrandPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const oneBrandActions = oneBrand.actions
export default oneBrand.reducer
